/**
 * Log level.
 */
export enum LogLevel {
  TRACE = 0,
  INFO,
  WARN,
  ERROR,
  SILENT
}
